import { render, staticRenderFns } from "./NewQuery.vue?vue&type=template&id=d2c294b2&scoped=true&"
import script from "./NewQuery.vue?vue&type=script&lang=js&"
export * from "./NewQuery.vue?vue&type=script&lang=js&"
import style0 from "./NewQuery.vue?vue&type=style&index=0&id=d2c294b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c294b2",
  null
  
)

export default component.exports